import { ApiModule } from '~/clientApi/ApiModule';

const MODULE = 'creator-insights';

const creatorInsights = (apiInstance) => new ApiModule(apiInstance, MODULE);

export default creatorInsights;
